import axios from "axios";

const apiUrl = 'https://hmy-lz-api-token.fly.dev'

export interface BridgeToken {
  hrc20Address: string
  erc20Address: string
  proxyERC20: string
  proxyHRC20: string
  name: string
  symbol: string
  decimals: string
  totalLocked: string
  totalSupply: string
  totalLockedNormal: string
  token: string
  type: BridgeTokenType
  network: BridgeNetwork
  image: string
  adapterParams: string
  adapterParamsEth: string
  usdPrice: string
}

export const getTokens = async () => {
  const { data } = await axios.get<{ content: BridgeToken[] }>(`${apiUrl}/tokens`)
  return data.content.map(item => {
    return {
      ...item,
      usdPrice: item.usdPrice.toString()
    }
  })
}

export interface BridgeConfigContracts {
  busd: string
  busdManager: string
  erc20Manager: string
  erc721Manager: string
  erc1155Manager: string
  erc1155TokenManager: string
  ethManager: string
  hrc20Manager: string
  hrc721Manager: string
  hrc721TokenManager: string
  hrc1155Manager: string
  hrc1155TokenManager: string
  link: string
  linkManager: string
  multisigWallet: string
  nativeTokenHRC20: string
  tokenManager: string
}

export interface BridgeChainConfig {
  contracts: BridgeConfigContracts
  explorerURL: string
  gasLimit: number
  gasPrice: number
  nodeURL: string
  tokens: string[]
}

export interface BridgeConfig {
  ARBITRUM?: BridgeChainConfig
}

export const getConfig = async () => {
  const { data } = await axios.get<BridgeConfig>(`${apiUrl}/config`)
  return data
}

export enum BridgeOperationType {
  ethToOne = 'eth_to_one',
  oneToEth = 'one_to_eth'
}

export enum BridgeTokenType {
  ALL = 'all',
  BUSD = 'busd',
  LINK = 'link',
  ERC20 = 'erc20',
  HRC20 = 'hrc20',
  ETH = 'eth',
  ONE = 'one',
  ERC721 = 'erc721',
  HRC721 = 'hrc721',
  ERC1155 = 'erc1155',
  HRC1155 = 'hrc1155',
}

export enum BridgeNetwork {
  ETHEREUM = 'ETHEREUM',
  BINANCE = 'BINANCE',
  ARBITRUM = 'ARBITRUM',
  HARMONY = 'HARMONY',
  LINEA = 'LINEA',
  BASE = 'BASE',
}

export interface CreateBridgeOperationParams {
  oneAddress: string
  ethAddress: string
  amount: string
  approveAmount: string
  erc20Address: string
  hrc20Address: string
  hrc721Address: string
  nftName: string
  nftImageUrl: string
  ensName: string
  type: BridgeOperationType
  token: BridgeTokenType
  network: BridgeNetwork
  id: string
}

export const createOperation = async (params: CreateBridgeOperationParams) => {
  const { data } = await axios.post<BridgeOperation>(`${apiUrl}/operations`, params)
  return data
}

export enum BridgeOperationStatus {
  error = 'error',
  success = 'success',
  waiting = 'waiting',
  inProgress = 'in_progress',
  canceled = 'canceled',
}

export enum BridgeOperationActionType {
  // ALL
  'depositOne' = 'depositOne',
  'withdrawOne' = 'withdrawOne',

  // ETH_TO_ONE
  'getHRC20Address' = 'getHRC20Address',
  'approveEthManger' = 'approveEthManger',
  'lockToken' = 'lockToken',
  'waitingBlockNumber' = 'waitingBlockNumber',
  'mintToken' = 'mintToken',
  'mintTokenRollback' = 'mintTokenRollback',

  // ONE_TO_ETH
  'approveHmyManger' = 'approveHmyManger',
  'burnToken' = 'burnToken',
  'waitingBlockNumberHarmony' = 'waitingBlockNumberHarmony',
  'unlockToken' = 'unlockToken',
  'unlockTokenRollback' = 'unlockTokenRollback',
  'topUpAccount' = 'topUpAccount',

  // HRC20
  'approveHRC20HmyManger' = 'approveHRC20HmyManger',
  'approveHRC20EthManger' = 'approveHRC20EthManger',
  'getERC20Address' = 'getERC20Address',
  'lockHRC20Token' = 'lockHRC20Token',
  'unlockHRC20Token' = 'unlockHRC20Token',
  'burnHRC20Token' = 'burnHRC20Token',
  'mintHRC20Token' = 'mintHRC20Token',
  'unlockHRC20TokenRollback' = 'unlockHRC20TokenRollback',
  'mintHRC20TokenRollback' = 'mintHRC20TokenRollback',

  // HRC721
  'getHRC721Address' = 'getHRC721Address',
  'approveHRC721HmyManger' = 'approveHRC721HmyManger',
  'approveHRC721EthManger' = 'approveHRC721EthManger',
  'lockHRC721Token' = 'lockHRC721Token',
  'unlockHRC721Token' = 'unlockHRC721Token',
  'burnHRC721Token' = 'burnHRC721Token',
  'mintHRC721Token' = 'mintHRC721Token',
  'unlockHRC721TokenRollback' = 'unlockHRC721TokenRollback',
  'mintHRC721TokenRollback' = 'mintHRC721TokenRollback',

  // HRC1155
  'getHRC1155Address' = 'getHRC1155Address',
  'approveHRC1155HmyManger' = 'approveHRC1155HmyManger',
  'approveHRC1155EthManger' = 'approveHRC1155EthManger',
  'lockHRC1155Token' = 'lockHRC1155Token',
  'unlockHRC1155Token' = 'unlockHRC1155Token',
  'burnHRC1155Token' = 'burnHRC1155Token',
  'mintHRC1155Token' = 'mintHRC1155Token',
  'unlockHRC1155TokenRollback' = 'unlockHRC1155TokenRollback',
  'mintHRC1155TokenRollback' = 'mintHRC1155TokenRollback',

  // ERC1155
  'getERC1155Address' = 'getERC1155Address',
  'approveERC1155HmyManger' = 'approveERC1155HmyManger',
  'approveERC1155EthManger' = 'approveERC1155EthManger',
  'lockERC1155Token' = 'lockERC1155Token',
  'unlockERC1155Token' = 'unlockERC1155Token',
  'burnERC1155Token' = 'burnERC1155Token',
  'mintERC1155Token' = 'mintERC1155Token',
  'unlockERC1155TokenRollback' = 'unlockERC1155TokenRollback',
  'mintERC1155TokenRollback' = 'mintERC1155TokenRollback',
}

export interface BridgeOperationAction {
  id: string
  isRequired: boolean
  payload: null
  status: BridgeOperationStatus
  type: BridgeOperationActionType
  error?: string
  transactionHash?: string
  timestamp?: number
}

export interface BridgeOperation extends CreateBridgeOperationParams {
  timestamp: number
  status: BridgeOperationStatus
  tokenType: 'main'
  actions: BridgeOperationAction[]
}

export const getOperation = async (id: string) => {
  const { data } = await axios.get<BridgeOperation>(`${apiUrl}/operations/${id}`)
  return data
}


export const confirmOperation = async (
  operationId: string,
  type: BridgeOperationActionType,
  transactionHash: string
) => {
  const { data } = await axios.post<BridgeOperation>(
    `${apiUrl}/operations/${operationId}/actions/${type}/confirm`,
    { transactionHash }
  )
  return data
}
